import store from '../store/index'
import { logToConsole } from './index'
import posthog from 'posthog-js'

const getSubdomain = () => {
  // Get the hostname from the current URL
  const { hostname } = window.location

  // Remove "www." from the hostname if it exists
  const sanitizedDomain = hostname.startsWith('www.')
    ? hostname.slice(4)
    : hostname

  return sanitizedDomain
}

class Analytics {
  static _instance = null
  mayaId = null
  clientId = null

  static getInstance() {
    if (!Analytics._instance) {
      Analytics._instance = new Analytics()
    }
    return Analytics._instance
  }

  initialize({ mayaIdGA4, clientIdGA4 }) {
    if (!this._initializedGA4 && (mayaIdGA4 || clientIdGA4)) {
      this.mayaId = mayaIdGA4
      this.clientId = clientIdGA4

      let isTestModeOrTestUser = false
      // EITHER BASED ON ENV OR BASED ON TEST CHAT DEBUG MODE WILL BE TRUE
      if (process.env.REACT_APP_API_ENV !== 'production') {
        isTestModeOrTestUser = true
      }
      if (store.getState().maya.isTestCase) {
        isTestModeOrTestUser = true
      }

      /* @ts-ignore */
      window.dataLayer = window.dataLayer || []
      /* @ts-ignore */
      window.gtag = function () {
        window.dataLayer.push(arguments)
      }
      /* @ts-ignore */
      window.gtag('js', new Date())
      if (this.mayaId) {
        /* @ts-ignore */
        window.gtag('config', this.mayaId, {
          groups: 'mayaAnalytics',
          debug_mode: isTestModeOrTestUser,
        })
      }

      if (this.clientId) {
        /* @ts-ignore */
        window.gtag('config', this.clientId, {
          groups: 'mayaAnalytics',
          debug_mode: isTestModeOrTestUser,
        })
      }
      this._initializedGA4 = true
      logToConsole('GA4 Analytics instance is initialized')
    }
  }

  sendEvent(name, params) {
    const baseInfo = {
      url: window.location.href,
      chat_id: store.getState().maya.slug,
      environment: process.env.REACT_APP_API_ENV,
      mode: store.getState().general.widgetMode,
      language: store.getState().general.language,
      test_user: store.getState().maya.isTestCase,
      domain: getSubdomain(),
      organization: store.getState().maya.organizationDetails?.slug,
    }

    let organizationSlug = store.getState().maya.organizationDetails?.slug

    if (organizationSlug === 'zoover' && window.dataLayer) {
      window.dataLayer.push({
        event: name,
        ...params,
        ...baseInfo,
      })
    }

    if (this.clientId || this.mayaId) {
      // SEND TO OUR CUSTOM GENERATED mayaAnalytics GROUP
      window.gtag('event', name, {
        send_to: 'mayaAnalytics',
        ...params,
        ...baseInfo,
      })
    }

    const organizationDetails = store.getState().maya.organizationDetails

    // SEND POSTHOG EVENTS ONLY ON PRODUCTION ENV
    if (
      process.env.REACT_APP_POSTHOG_API_KEY &&
      process.env.REACT_APP_POSTHOG_API_HOST &&
      process.env.REACT_APP_API_ENV === 'production' &&
      organizationDetails.enablePosthogAnalytics
    )
      this.sendEventToPosthog(name, params, baseInfo)
  }

  sendEventToPosthog(name, params, baseInfo) {
    const postHogId = posthog.get_distinct_id()
    const chatSlug = store.getState().maya.slug

    if (postHogId !== chatSlug) {
      posthog.identify(
        chatSlug, // Required. Replace 'distinct_id' with your user's unique identifier
        { test_user: baseInfo.test_user, language: baseInfo.language } // $set, optional
      )
    }

    logToConsole('Posthog event', name)

    posthog.capture(name, {
      ...params,
      ...baseInfo,
    })
  }
}

export default Analytics
